import { DEVICE_PATH } from '@/constants/apiPaths'
import { AbstractApiService } from '@/services/abstractApiService'
import { PER_PAGE_NOT_PAGINATED } from '@/constants/commons.ts'
import { createFilterScopesString } from '@/assets/js/main.ts'

class DeviceService extends AbstractApiService {
  public constructor() {
    super('')
  }

  public async show(id: any) {
    return this.http
      .get(`${DEVICE_PATH}/${id}`)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async index(
    page: number,
    perPage: number,
    sort?: string | null,
    search?: string | null,
    filterScopes?: Map<string, string>,
    endpoint?: string | null
  ) {
    return this.http
      .get(
        `${DEVICE_PATH}${endpoint == null ? '' : endpoint}?page=${page}&perPage=${perPage}&sort=${sort}&search=${search}${createFilterScopesString(filterScopes)}`
      )
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async getDevicesForSelect() {
    return this.http
      .get(`${DEVICE_PATH}?page=0&perPage=${PER_PAGE_NOT_PAGINATED}`)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async manage(params: any, id: any) {
    if (id != null) {
      await this.update(params, id)
    } else {
      await this.create(params)
    }
  }

  public async create(params: any) {
    return this.http
      .post(DEVICE_PATH, params)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async update(params: any, id: any) {
    return this.http
      .patch(DEVICE_PATH + `/${id}`, params)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async delete(id: any) {
    return this.http
      .delete(DEVICE_PATH + `/${id}`)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }
}

export const deviceService: DeviceService = new DeviceService()
